export default "__VITE_ASSET__BeL93hvl__"